"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UITypeahead = _interopRequireDefault(require("UIComponents/typeahead/UITypeahead"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _utils = require("../utils/utils");

var _langUtils = require("../utils/langUtils");

var ALL_GOOD_TYPE_OPTIONS = [_GoodSubTypes.default.EMAIL_TEMPLATES, _GoodSubTypes.default.LANDING_PAGES, _GoodSubTypes.default.SITE_PAGES, _GoodSubTypes.default.BLOG_TEMPLATES, _GoodSubTypes.default.PACKS, _GoodSubTypes.default.UNSUBSCRIBE_SIMPLE, _GoodSubTypes.default.ERROR_PAGE, _GoodSubTypes.default.PASSWORD_PAGE, _GoodSubTypes.default.SUBSCRIPTION_PREFERENCES, _GoodSubTypes.default.UNSUBSCRIBE_CONFIRMATION, _GoodSubTypes.default.CONTENT_SEARCH_RESULTS];

var GoodSubTypeDropdown = function GoodSubTypeDropdown(_ref) {
  var buttonClassName = _ref.buttonClassName,
      onSubTypeChange = _ref.onSubTypeChange,
      subTypeOptions = _ref.subTypeOptions,
      value = _ref.value;
  return _react.default.createElement(_UIDropdown.default, {
    buttonClassName: "p-all-0 " + buttonClassName,
    buttonText: (0, _langUtils.getFriendlyCategoryFilterName)(value),
    buttonUse: "transparent",
    placement: "bottom right"
  }, _react.default.createElement(_UITypeahead.default, {
    onChange: onSubTypeChange,
    options: (0, _utils.getAlphaSortedArrOfTextValPairsForSelect)(subTypeOptions || ALL_GOOD_TYPE_OPTIONS, _langUtils.getFriendlyCategoryFilterName, _GoodSubTypes.default.ALL),
    value: value
  }));
};

GoodSubTypeDropdown.propTypes = {
  buttonClassName: _react.PropTypes.string,
  onSubTypeChange: _react.PropTypes.func.isRequired,
  subTypeOptions: _react.PropTypes.arrayOf(_react.PropTypes.string),
  value: _react.PropTypes.string.isRequired
};
var _default = GoodSubTypeDropdown;
exports.default = _default;
module.exports = exports.default;